/* eslint-disable camelcase */
$(document)
  .off('keydown')
  .on('keydown', event => {
    let doPrevent = false;
    if (event.keyCode === 8) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'srcElement' does not exist on type 'KeyD... Remove this comment to see the full error message
      const d = event.srcElement || event.target;
      if (d.tagName.toUpperCase() === 'INPUT' || d.tagName.toUpperCase() === 'TEXTAREA') {
        doPrevent = false;
      } else {
        doPrevent = true;
      }
    }

    if (doPrevent) {
      event.preventDefault();
    }
  });

/**
 * Enable shortcuts while focused on input fields.
 */

$(() => {
  $.hotkeys.options.filterInputAcceptingElements = false;
  $.hotkeys.options.filterContentEditable = false;
  $.hotkeys.options.filterTextInputs = false;
});

/**
 * Trigger change validation before hitting enter on a currency field.
 */

$(document).on('keydown', 'input.money', function onMoney(event) {
  if (event.keyCode === 13) {
    event.preventDefault();
    $(this)
      .trigger('change')
      .trigger($.Event('keypress', { which: 13 }));
  }
});

window.closeIframes = function closeIframes() {
  $('iframe').fadeOut();
  return false;
};

window.getEventKeyCode = function getEventKeyCode(e) {
  if (e.keyCode) {
    return e.keyCode;
  } // for moz/fb, if keyCode==0 use which
  if (typeof e.which !== 'undefined' && e.type.indexOf('key') !== -1) {
    return e.which;
  }
  return 0;
};

window.onCustomKey = function onCustomKey(event, key, fnc) {
  if (window.getEventKeyCode(event) === key) {
    if (!event.repeat) {
      fnc();
      return true;
    }
  }
  return false;
};

window.onTabKey = function onTabKey(event, fnc) {
  return window.onCustomKey(event, 9, fnc);
};
window.onEnterKey = function onEnterKey(event, fnc) {
  return window.onCustomKey(event, 13, fnc);
};
window.onSpaceKey = function onSpaceKey(event, fnc) {
  return window.onCustomKey(event, 32, fnc);
};

window.alt_href = function alt_href(href, name, event) {
  if (href) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    event.preventDefault();
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    event.stopPropagation();
    window.merchantos.utils.openUrl(href);
    return;
  }
  if (name) {
    window.navigateToContent('listing', name);
  }
};

class Keyboard implements MerchantosKeyboard {
  keys: { [key: string]: KeyboardCallback };

  permanent_keys: { [key: string]: KeyboardCallback };

  stored_keys: { [key: string]: KeyboardCallback };

  constructor() {
    this.keys = {};
    this.permanent_keys = {};
    this.stored_keys = {};
  }

  permanent_subscribe = (key: string, action: KeyboardCallback) => {
    // eslint-disable-next-line no-param-reassign
    key = key.toLowerCase();

    // Standard subscribe
    this.subscribe(key, action);

    // Remove from default keys to prevent storage
    delete this.keys[key];

    // Store to prevent double binding later
    this.permanent_keys[key] = action;
  };

  subscribe = (key: string, action: KeyboardCallback) => {
    // eslint-disable-next-line no-param-reassign
    key = key.toLowerCase();

    this.unsubscribe(key);

    this.keys[key] = action;

    // Bind the key event
    $(document).on('keydown', '', key, action);
  };

  unsubscribe = (key: string) => {
    // eslint-disable-next-line no-param-reassign
    key = key.toLowerCase();

    // Unregister from keys
    if (this.keys[key] !== undefined) {
      $(document).off('keydown', '', this.keys[key]);
      delete this.keys[key];
    }

    // Unregister from permanent keys
    if (this.permanent_keys[key] !== undefined) {
      $(document).off('keydown', '', this.permanent_keys[key]);
      delete this.permanent_keys[key];
    }
  };

  // store the current key subscriptions and clear them from being active
  store = () => {
    this.stored_keys = {};
    // eslint-disable-next-line
    for (const key in this.keys) {
      // Store in case we need to rebuild later
      this.stored_keys[key] = this.keys[key];
      this.unsubscribe(key);
    }
    this.keys = {};
  };

  // restore the stored key subscriptions and clear any current ones
  restore = () => {
    // eslint-disable-next-line
    for (const key in this.keys) {
      if (this.stored_keys[key] !== undefined) {
        this.subscribe(key, this.stored_keys[key]);
        // eslint-disable-next-line no-continue
        continue;
      }
      // Nuke any keys that weren't overwritten above
      this.unsubscribe(key);
    }

    this.stored_keys = {};
  };
}

window.merchantos.keyboard = new Keyboard();

window.merchantos.keyboard.permanent_subscribe('f1', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  event.stopPropagation();
  window.merchantos.tabs.show('help');
});

window.merchantos.keyboard.permanent_subscribe('f2', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  event.stopPropagation();
  window.merchantos.tabs.show('register');
});

window.merchantos.keyboard.permanent_subscribe('f3', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  event.stopPropagation();
  window.merchantos.tabs.show('inventory');
});

window.merchantos.keyboard.permanent_subscribe('f4', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  event.stopPropagation();
  window.merchantos.tabs.show('service');
});

window.merchantos.keyboard.permanent_subscribe('f5', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  event.stopPropagation();
  window.merchantos.tabs.show('customers');
});

window.merchantos.keyboard.permanent_subscribe('f10', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  event.stopPropagation();
  window.merchantos.timeClock.showClockInOut();
});

window.merchantos.keyboard.permanent_subscribe('f12', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  event.stopPropagation();
  window.verifyWithPIN();
});

window.merchantos.keyboard.permanent_subscribe('Alt+x', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  window.hideAllNotifiers();

  // Find all close buttons and trigger onclick event on each

  // See if we have any close links and don't deal with buttons if so.
  $.each($('button.close:visible'), (_index, button) => window.onclickRunner(button));
});

/**
 * Some of the Alt shortcuts are reporting the wrong character code while focused on an input element
 * or insert a character even if we prevent the default behaviour, to avoid this when Alt is pressed
 * for the first time we remove the element focus, it doesn't work on successive Alt+ shortcuts though.
 */

window.merchantos.keyboard.permanent_subscribe('Alt', event => {
  if (event.target.dataset.type === 'email') return;

  $(event.target).blur();
});

window.merchantos.keyboard.permanent_subscribe('Alt+1', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href('/register.php', null, event);
});

window.merchantos.keyboard.permanent_subscribe('Alt+2', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href('/register.php?form_name=new_transaction', null, event);
});

window.merchantos.keyboard.permanent_subscribe('Alt+3', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href(null, 'item.listings.items', event);
});

window.merchantos.keyboard.permanent_subscribe('Alt+4', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href(null, 'workbench.listings.workorders', event);
});

window.merchantos.keyboard.permanent_subscribe('Alt+5', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href(null, 'customer.listings.customers', event);
});

window.merchantos.keyboard.permanent_subscribe('Alt+7', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href(null, 'purchase.listings.purchases', event);
});

window.merchantos.keyboard.permanent_subscribe('Alt+8', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href(null, 'special_order.listings.special_orders', event);
});

window.merchantos.keyboard.permanent_subscribe('Alt+9', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href(null, 'item.listings.labels', event);
});

window.merchantos.keyboard.permanent_subscribe('Alt+0', event => {
  if (event.target.dataset.type === 'email') return;

  event.preventDefault();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  window.alt_href('/register.php?form_name=disp_gift_card_check', null, event);
});

window.onclickRunner = function onclickRunner(element) {
  const onclick = $(element).attr('onclick');
  // TODO: This doesn't seem to exist
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'srcWithinBounds' does not exist on type ... Remove this comment to see the full error message
  let onclick_clean = window.srcWithinBounds?.(onclick.toString().replace(/\n/g, ''), '{', '}', 1);

  // Remove "return false" (not needed since we already called preventDefault)
  const re = /return false;$/;
  onclick_clean = onclick_clean?.replace(re, '');

  if (onclick_clean?.length > 0) {
    // eslint-disable-next-line no-eval
    eval(onclick_clean);
  }
};
